module.exports = __webpack_public_path__ + "static/media/prod18.3701769a.png";